// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"SV-z","inlineTitle":"TV-z","sponsoredAdsWrapper":"UV-z","marketplaceRecosWrapper":"VV-z"};